// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shareEntityButtonStyles } from "@guestsupply/Overrides/Components/ShareEntityButton";
import translate from "@insite/client-framework/Translate";
import { css } from "styled-components";

shareEntityButtonStyles.messageTextArea = {
    css: css`
        resize: vertical;
    `,
};

shareEntityButtonStyles.button = {
    variant: "secondary",
};

shareEntityButtonStyles.emailToTextField = {
    placeholder: translate("eg. example@gmail.com"),
};

shareEntityButtonStyles.emailFromTextField = {
    placeholder: translate("eg. example@gmail.com"),
};

shareEntityButtonStyles.subjectTextField = {
    placeholder: translate("eg. Order ######"),
};

shareEntityButtonStyles.messageTextArea = {
    placeholder: translate("Message"),
};

shareEntityButtonStyles.container = {
    gap: 20,
};

shareEntityButtonStyles.buttonsWrapper = {
    css: css`
        margin-top: 20px;
        text-align: right;
    `,
};

shareEntityButtonStyles.loadingOverlay = {
    ...shareEntityButtonStyles.loadingOverlay,
    css: css`
        & div[class^="SpinnerWrapper"] {
            position: absolute;
            top: 50%;
            left: 50%;
            right: auto;
            bottom: auto;
            margin: auto;
            transform: translate(-50%, -50%);
        }
    `,
};
